import React from "react";
import "./Featured.css";
import FeturedOn1 from "../../../Assets/Accreditations/f_logo1.png";
import FeturedOn2 from "../../../Assets/Accreditations/f_logo2.png";
import FeturedOn3 from "../../../Assets/Accreditations/f_logo3.png";
import FeturedOn4 from "../../../Assets/Accreditations/f_logo4.png";
import FeturedOn5 from "../../../Assets/Accreditations/f_logo5.png";
// import FeturedOn6 from "../../../Assets/Accreditations/logo1.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Featured() {
  return (
    <div className="FeaturedOn">
      <h2>Featured on</h2>
      <div className="featured_six_divs_New">
        <div className="Featured_divs">
          {/* <a
            href="https://economictimes.indiatimes.com/industry/healthcare/biotech/healthcare/redcliffe-labs-plans-to-hire-over-1000-persons-in-next-six-months/articleshow/88127206.cms"
            target="_blank"
          > */}
            <LazyLoadImage
              src={FeturedOn1}
              alt="ICMR"
              delayTime="100"
              width="100%"
            />
          {/* </a> */}
        </div>
        <div className="Featured_divs">
          {/* <a
            href="https://www.businesswire.com/news/home/20211230005124/en/India-Oncology-NGS-Market-Size-Share-Trends-Analysis-2021-2028-A-70.60-Million-Market-by-2028---ResearchAndMarkets.com"
            target="_blank"
          > */}
            <LazyLoadImage
              src={FeturedOn2}
              alt="ISO"
              delayTime="100"
              width="100%"
            />
          {/* </a> */}
        </div>
        <div className="Featured_divs">
          {/* <a
            href="https://www.vccircle.com/chiratae-backed-healthtech-startup-redcliffe-lifetech-eyes-up-to-60-mn-in-fresh-funding"
            target="_blank"
          > */}
            <LazyLoadImage
              src={FeturedOn3}
              alt="NABL"
              delayTime="100"
              width="100%"
            />
          {/* </a> */}
        </div>
        <div className="Featured_divs">
          {/* <a
            href="https://timesofindia.indiatimes.com/business/india-business/gland-pharma-q2-net-up-38/articleshow/87213616.cms"
            target="_blank"
          > */}
            <LazyLoadImage
              src={FeturedOn4}
              alt="CRYSTA"
              delayTime="100"
              width="100%"
            />
          {/* </a> */}
        </div>
        <div className="Featured_divs">
          {/* <a
            href="https://www.financialexpress.com/lifestyle/health/diagnostics-sector-has-witnessed-changes-due-to-covid-19-towards-home-based-diagnostics-dheeraj-jain/2305782/"
            target="_blank"
          > */}
            <LazyLoadImage
              src={FeturedOn5}
              alt="CRYSTA"
              delayTime="100"
              width="100%"
            />
          {/* </a> */}
        </div>
        {/* <div className="Featured_divs">
          {" "}
          <LazyLoadImage src={FeturedOn6} alt="CRYSTA" delayTime='100' width="100%" />
        </div> */}
      </div>
    </div>
  );
}
